import { useAppConfig } from '../context/AppConfigContext.js';

/**
 * The amber "TRAINING" banner shown above the header (and at the top of the
 * Login page) whenever the app is running in training mode. Renders nothing
 * at all in production - see training-env spec §4.
 */
export function TrainingStrip() {
  const { environment } = useAppConfig();
  if (environment !== 'training') return null;

  return (
    <div
      className="flex h-7 w-full items-center justify-center px-2 text-center font-body text-sm font-semibold"
      style={{ backgroundColor: 'var(--training-strip)', color: 'var(--ink)' }}
    >
      <span className="hidden sm:inline">TRAINING &middot; practice only &mdash; not real sales</span>
      <span className="sm:hidden">TRAINING &middot; not real sales</span>
    </div>
  );
}
